module.exports = __webpack_public_path__ + "media/application/images/svgs/play-circle-5f58ca0ee4d4f4ace14b89ebcb1309fb.svg";